'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.iconList = undefined;

var _NitroIcon = require('./NitroIcon');

var _NitroIcon2 = _interopRequireDefault(_NitroIcon);

var _iconList = require('./iconList');

var _iconList2 = _interopRequireDefault(_iconList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var iconList = exports.iconList = _iconList2.default;

exports.default = _NitroIcon2.default;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/index.js
// module id = 9
// module chunks = 4